<template>
    <div class="page page-index" :style="{'backgroundImage': 'url('+bg+')'}" :class="{'hidden-scroll': menuState}"
         id="index" @scroll="changeMenuClass">
        <div class="page-index-content" ref="content">
            <preview-app :matches="matches" @changedStatistic="getStatistic"></preview-app>
            <div class="wrapper" v-if="statistic">
                <div class="mobile-show" v-if="$root.isMobile">
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_3_1_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_3_1_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])}"
                               :titleAway="{number: statistic.b_right_3_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_3_2_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])}"
                               :textHome="statistic.b_right_3_1_text"
                               :textAway="statistic.b_right_3_2_text"
                               :icon="'pass'"
                               class="first"

                    />
                    <router-link class="swift" :class="banners[statistic.banner_right_1].className" @click.native="gaEvent('main', 'click', banners[statistic.banner_left_1].className)"
                                 :to="banners[statistic.banner_right_1].link">
                        <div class="overlay" :style="{backgroundImage: 'url('+banners[statistic.banner_right_1].img+')'}"></div>
                        <div class="logo"></div>
                        <div class="product-body">
                            <div class="name">
                                <span>{{banners[statistic.banner_right_1].name}}</span>
                            </div>
                            <div class="time">
                                <span v-html="banners[statistic.banner_right_1].title"></span>
                            </div>
                            <div class="descr">
                                <span>{{banners[statistic.banner_right_1].desc}}</span>
                            </div>
                            <div class="more"><span>Узнать больше</span></div>
                        </div>
                    </router-link>
                </div>
                <div class="leftside">
                    <bigView :countryName="currentMatch.fkParticipants1.name"
                             :countryFlag="currentMatch.fkParticipants1.image"
                             :icon="'move'"
                             :titleNumber="statistic.b_left_1_count"
                             :titleText="$root.Helpers.declension(statistic.b_left_1_count, ['передачу', 'передачи', 'передач'])"
                             :contentText="statistic.b_left_1_text"
                    />
                    <bigView :countryName="currentMatch.fkParticipants2.name"
                             :countryFlag="currentMatch.fkParticipants2.image"
                             :icon="'move'"
                             :titleNumber="statistic.b_left_2_count"
                             :titleText="$root.Helpers.declension(statistic.b_left_2_count, ['передачу', 'передачи', 'передач'])"
                             :contentText="statistic.b_left_2_text"
                    />
                </div>
                <div class="rightside">
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_1_1_count+'%', hasBr: true, text: 'единоборств'}"
                               :titleAway="{number: statistic.b_right_1_2_count+'%', hasBr: true, text: 'выигранных единоборств'}"
                               :textHome="statistic.b_right_1_1_text"
                               :textAway="statistic.b_right_1_2_text"

                    />
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_2_1_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_2_1_count, ['передачу', 'передачи', 'передач'])}"
                               :titleAway="{number: statistic.b_right_2_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_2_2_count, ['передачу', 'передачи', 'передач'])}"
                               :textHome="statistic.b_right_2_1_text"
                               :textAway="statistic.b_right_2_2_text"
                               :icon="'exchange'"

                    />
                    <div class="mobile-hidden" v-if="!$root.isMobile">
                        <router-link class="swift" :class="banners[statistic.banner_right_1].className" @click.native="gaEvent('main', 'click', banners[statistic.banner_left_1].className)"
                                     :to="banners[statistic.banner_right_1].link">
                            <div class="overlay" :style="{backgroundImage: 'url('+banners[statistic.banner_right_1].img+')'}"></div>
                            <div class="logo"></div>
                            <div class="product-body">
                                <div class="name">
                                    <span>{{banners[statistic.banner_right_1].name}}</span>
                                </div>
                                <div class="time">
                                    <span v-html="banners[statistic.banner_right_1].title"></span>
                                </div>
                                <div class="descr">
                                    <span>{{banners[statistic.banner_right_1].desc}}</span>
                                </div>
                                <div class="more"><span>Узнать больше</span></div>
                            </div>
                        </router-link>
                        <smallView :countryHome="currentMatch.fkParticipants1.image"
                                   :countryAway="currentMatch.fkParticipants2.image"
                                   :titleHome="{number: statistic.b_right_3_1_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_3_1_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])}"
                                   :titleAway="{number: statistic.b_right_3_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_3_2_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])}"
                                   :textHome="statistic.b_right_3_1_text"
                                   :textAway="statistic.b_right_3_2_text"
                                   :icon="'pass'"

                        />
                    </div>
                </div>
                <div class="leftside">
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_left_3_1_count, hasBr: false, text:$root.Helpers.declension(statistic.b_left_3_1_count, ['удар', 'удара', 'ударов'])}"
                               :titleAway="{number: statistic.b_left_3_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_left_3_2_count, ['удар', 'удара', 'ударов'])}"
                               :textHome="statistic.b_left_3_1_text"
                               :textAway="statistic.b_left_3_2_text"
                               :icon="'ball'"

                    />
                    <router-link class="swift swift--small" :class="banners[statistic.banner_left_1].className" @click.native="gaEvent('main', 'click', banners[statistic.banner_left_1].className)"
                                 :to="banners[statistic.banner_left_1].link">
                        <div class="overlay" :style="{backgroundImage: 'url('+banners[statistic.banner_left_1].img+')'}"></div>
                        <div class="logo"></div>
                        <div class="product-body">
                            <div class="name">
                                <span>{{banners[statistic.banner_left_1].name}}</span>
                            </div>
                            <div class="time">
                                <span v-html="banners[statistic.banner_left_1].title"></span>
                            </div>
                            <div class="descr">
                                <span>{{banners[statistic.banner_left_1].desc}}</span>
                            </div>
                            <div class="more"><span>Узнать больше</span></div>
                        </div>
                    </router-link>
                </div>
                <div class="rightside">
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_4_1_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_4_1_count, ['удар', 'удара', 'ударов'])}"
                               :titleAway="{number: statistic.b_right_4_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_4_2_count, ['удар', 'удара', 'ударов'])}"
                               :textHome="statistic.b_right_4_1_text"
                               :textAway="statistic.b_right_4_2_text"
                               :icon="'kickGreen'"

                    />
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_5_1_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_5_1_count, ['острую передачу', 'острых передачи', 'острых передач'])}"
                               :titleAway="{number: statistic.b_right_5_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_5_2_count, ['острую передачу', 'острых передачи', 'острых передач'])}"
                               :textHome="statistic.b_right_5_1_text"
                               :textAway="statistic.b_right_5_2_text"
                               :backgroundImg="'url(/static/img/pages/main/block_img_2.png)'"
                    />
                </div>
                <div class="leftside">
                    <bigView :countryName="currentMatch.fkParticipants1.name"
                             :countryFlag="currentMatch.fkParticipants1.image"
                             :icon="'move'"
                             :titleNumber="statistic.b_left_4_count"
                             :titleText="$root.Helpers.declension(statistic.b_left_4_count, ['ключевую передачу', 'ключевые передачи', 'ключевых передач'])"
                             :contentText="statistic.b_left_4_text"
                             :backgroundImg="'url(/static/img/pages/main/block_img_1.png)'"
                    />
                    <bigView :countryName="currentMatch.fkParticipants2.name"
                             :countryFlag="currentMatch.fkParticipants2.image"
                             :icon="'move'"
                             :titleNumber="statistic.b_left_5_count"
                             :titleText="$root.Helpers.declension(statistic.b_left_5_count, ['ключевую передачу', 'ключевые передачи', 'ключевых передач'])"
                             :contentText="statistic.b_left_5_text"
                             :backgroundImg="'url(/static/img/pages/main/block_img_1.png)'"
                    />
                </div>
                <div class="rightside">
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_6_1_count + '%', hasBr: false, text: 'точных передач'}"
                               :titleAway="{number: statistic.b_right_6_2_count + '%', hasBr: false, text: 'точных передач'}"
                               :textHome="statistic.b_right_6_1_text"
                               :textAway="statistic.b_right_6_2_text"

                    />
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_7_1_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_7_1_count, ['точную передачу', 'точные передачи', 'точных передач'])}"
                               :titleAway="{number: statistic.b_right_7_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_7_2_count, ['точную передачу', 'точные передачи', 'точных передач'])}"
                               :textHome="statistic.b_right_7_1_text"
                               :textAway="statistic.b_right_7_2_text"
                               :icon="'kickRose'"

                    />
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_8_1_count + '%', hasBr: true, text: 'удачных отборов'}"
                               :titleAway="{number: statistic.b_right_8_2_count + '%', hasBr: true, text: 'удачных отборов'}"
                               :textHome="statistic.b_right_8_1_text"
                               :textAway="statistic.b_right_8_2_text"

                    />
                    <router-link class="swift" :class="banners[statistic.banner_right_2].className" @click.native="gaEvent('main', 'click', banners[statistic.banner_left_1].className)"
                                 :to="banners[statistic.banner_right_2].link">
                        <div class="overlay" :style="{backgroundImage: 'url('+banners[statistic.banner_right_2].img+')'}"></div>
                        <div class="logo"></div>
                        <div class="product-body">
                            <div class="name">
                                <span>{{banners[statistic.banner_right_2].name}}</span>
                            </div>
                            <div class="time">
                                <span v-html="banners[statistic.banner_right_2].title"></span>
                            </div>
                            <div class="descr">
                                <span>{{banners[statistic.banner_right_2].desc}}</span>
                            </div>
                            <div class="more"><span>Узнать больше</span></div>
                        </div>
                    </router-link>
                </div>
                <div class="leftside">
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_left_6_1_count, hasBr: false, text: $root.Helpers.declension(statistic.b_left_6_1_count, ['потерю', 'потери', 'потерь'])}"
                               :titleAway="{number: statistic.b_left_6_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_left_6_2_count, ['потерю', 'потери', 'потерь'])}"
                               :textHome="statistic.b_left_6_1_text"
                               :textAway="statistic.b_left_6_2_text"
                               :icon="'kickRose'"

                    />
                </div>
                <div class="rightside">
                    <smallView :countryHome="currentMatch.fkParticipants1.image"
                               :countryAway="currentMatch.fkParticipants2.image"
                               :titleHome="{number: statistic.b_right_9_1_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_9_1_count, ['удачную обводку', 'удачных обводки', 'удачных обводок'])}"
                               :titleAway="{number: statistic.b_right_9_2_count, hasBr: false, text: $root.Helpers.declension(statistic.b_right_9_2_count, ['удачную обводку', 'удачных обводки', 'удачных обводок'])}"
                               :textHome="statistic.b_right_9_1_text"
                               :textAway="statistic.b_right_9_2_text"
                               :icon="'tackle'"

                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    import preview from '@/components/common/preview';
    import bigView from '@/components/parts/bigView';
    import smallView from '@/components/parts/smallView';

    import banners from '@/configs/banners'

    export default {
        name: 'Index',
        props: ['supportsWEBP', 'bg'],
        data() {
            return {
                statistic: null,
                currentMatch: null,
                currentScrollPosition: null,
                banners: banners
            }
        },
        components: {
            'preview-app': preview,
            bigView,
            smallView,
        },
        methods: {
            gaEvent(category, action, label) {
                this.$root.gaSend(category, action, label);
            },
            getData() {
                this.$store.dispatch('getMatches');
            },
            getStatistic(data) {
                this.currentMatch = data;
                this.statistic = data.statistic;
            },
            changeMenuClass() {
                let dHeight = this.$refs['content'].clientHeight,
                    top = this.$el.scrollTop;

                if (top >= dHeight / 3 && top < dHeight / 3 * 2) {
                    this.currentScrollPosition = '30%'
                } else if (top >= dHeight / 3 * 2 && top < dHeight - this.$el.clientHeight) {
                    this.currentScrollPosition = '60%'
                } else if (top == dHeight - this.$el.clientHeight) {
                    this.currentScrollPosition = '100%'
                } else {
                    this.currentScrollPosition = null
                }

                let menuClass = (top > 0) ? true : false;
                this.$emit('changeMenuClass', menuClass);
            }
        },
        computed: {
            ...mapGetters({
                matches: 'getMatches',
                menuState: 'getMenuState'
            })
        },
        created() {
            this.getData();
        },
        watch: {
            currentMatch(to, from) {
                if (to) this.$root.gaSend('main', 'show', to.fkParticipants1.name + '-' + to.fkParticipants2.name);
            },
            currentScrollPosition(to, from) {
                if (to) this.$root.gaSend('main', 'scroll', to);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Index.vue?3269d8c7